import ActionsButton             from '@/components/actionsButton/ActionsButton';
import { Box }                   from '@chakra-ui/react';
import DeleteModal               from '@/components/deleteModal/DeleteModal';
import Image                     from '@/components/Image/Image';
import { Link }                  from 'react-router-dom';
import React                     from 'react';
import Spinner                   from '@/components/spinner/Spinner';
import { Text }                  from '@chakra-ui/react';
import dayjs                     from 'dayjs';
import { toaster }               from '@/components/ui/toaster';
import { useTranslation }        from 'react-i18next';
import UserEventModel            from '@/models/services/website/UserEventModel';
import WebsiteEntertainmentModel from '@/models/services/website/WebsiteEntertainmentModel';
import links                     from '@/tools/links';
import { formatEventDateLong }   from '@/tools/dayjs';
import { formatEventTimeRange }  from '@/tools/dayjs';

interface IAgendaListRowProps {
	agenda: UserEventModel;
	websiteEntertainment: WebsiteEntertainmentModel;
}

const AgendaListRow = (props: IAgendaListRowProps) => {
	const { agenda, websiteEntertainment } = props;
	const { t, i18n } = useTranslation();
	const [isLoading, setIsLoading] = React.useState(false);
	const [deleteModalIsOpen, setDeleteModalIsOpen] = React.useState(false);

	const { event } = agenda;
	const { date, endDate, place, startDate } = event;

	dayjs.locale(i18n.language);

	const getResourceUrl = (): string => {
		if (!websiteEntertainment.website?.url) return '';
		const baseUrl = websiteEntertainment.website.url;
		const year = websiteEntertainment.slugPrefix;
		const slug = event.slug;
		const lang = i18n.language;

		return `${baseUrl}/${links.event(lang, year, slug)}`;
	};

	const removeAgenda = async () => {
		try {
			setIsLoading(true);
			
			await agenda.destroy();

			toaster.create({
				title: t('pages.agenda.actions.destroy.success'),
				type: 'success'
			});
		} catch (error) {
			toaster.create({
				title: t('pages.agenda.actions.destroy.error'),
				type: 'error'
			});
			console.log(error);
		} finally {
			setIsLoading(false);
			setDeleteModalIsOpen(false);
		}
	}

	const dateLabel = event.dayIsFinal ? formatEventDateLong(
		date.valueOf(),
		t("app.time.long"),
	) : t("app.dateToBeDetermined");

	const timeRange = event.hourIsFinal ? formatEventTimeRange(
		startDate.valueOf(),
		endDate.valueOf(),
		t("app.time.separator"),
	) : t("app.hourToBeDetermined");

	console.log("event => ", event);
	

	if (isLoading) {
		return <Spinner />
	}

	return (
		<Box
			display="flex"
			alignItems="center"
			justifyContent="space-between"
		>
			<DeleteModal
				modalIsOpen={deleteModalIsOpen}
				deleteMessage={t('pages.agenda.actions.destroy.confirmDeletion')}
				onCancel={() => setDeleteModalIsOpen(false)}
				onConfirm={removeAgenda}
			/>
			<Link to={getResourceUrl()} target='_blank' style={{ width: "100%" }}>
				<Box
					display="flex"
					alignItems="center"
					gap="25px"
				>
					<Box
						minWidth="75px" 
						maxWidth="75px" 
						height="75px"
					>
						<Image errorSize='xl' borderRadius="md" src={event.getFiles('event_picture').at(0)?.url} />
					</Box>
					<Box
						display="flex"
						flexDirection="column"
						gap="5px"
						paddingRight="25px"
					>
						<Box><Text className='poppins-semibold' fontSize="16px" textDecoration="underline">{ event.getTitle(i18n.language) }</Text></Box>
						<Box>
							<Text>{`${dateLabel} ${event.dayIsFinal ? timeRange : ''}`}</Text>
							<Box
								display="flex"
								alignItems="center"
								gap="5px"
							>
								<Box 
									width="24px"
									height="100%"
									display="flex"
									flexDirection="column"
									alignItems="center"
									justifyContent="center"
									textAlign="center"
								>
									<Image src={place.getFiles("place_logo").at(0)?.url} />
								</Box>
								<Box><Text fontSize="12px">{place.getTitle(i18n.language)}</Text></Box>
							</Box>
						</Box>
					</Box>
				</Box>
			</Link>
			<ActionsButton actions={[ { label: t('pages.agenda.actions.destroy.label'), do: () => setDeleteModalIsOpen(true) } ]}/>
		</Box>
	)
}

export default AgendaListRow;